// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_solara_fluted_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_solara_fluted_shade: ModuleSchema = {
  "id": "core_solara_fluted_shade",
  "uniqueId": "B3D_M4R8T",
  "createdAt": "2026-10-11T09:56:36+00:00",
  "updatedAt": "2026-10-11T09:56:36+00:00",
  "label": "Solara Fluted Shade",
  "description": "Standalone Solara diffuser shade with smooth continuous vertical flutes and a mounting shelf.",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_SOLARA_SHADE",
    "solara",
    "fluted",
    "shade",
    "diffuser"
  ],
  "sliders": [
    {
      "key": "shadeDia",
      "label": "Shade Outer Diameter - Rib Tips",
      "min": 80,
      "max": 180,
      "step": 1,
      "default": 120,
      "unit": "mm"
    },
    {
      "key": "shadeCoreDia",
      "label": "Shade Inner Core Diameter - Trough",
      "min": 70,
      "max": 170,
      "step": 1,
      "default": 114,
      "unit": "mm"
    },
    {
      "key": "shadeHeight",
      "label": "Shade Column Height",
      "min": 60,
      "max": 180,
      "step": 1,
      "default": 109.1,
      "unit": "mm"
    },
    {
      "key": "shadeRibCount",
      "label": "Shade Flutes Count - Ribs",
      "min": 30,
      "max": 100,
      "step": 2,
      "default": 60,
      "unit": "ribs"
    },
    {
      "key": "wallThickness",
      "label": "Diffuser Wall Thickness",
      "min": 0.8,
      "max": 3,
      "step": 0.1,
      "default": 1,
      "unit": "mm"
    },
    {
      "key": "mountHoleDia",
      "label": "Mounting Hole Diameter",
      "min": 20,
      "max": 80,
      "step": 0.1,
      "default": 41,
      "unit": "mm"
    },
    {
      "key": "shelfThickness",
      "label": "Mounting Shelf Thickness",
      "min": 1,
      "max": 10,
      "step": 0.1,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "basePadSlotInnerDia",
      "label": "Pad Slot Inner Diameter",
      "min": 20,
      "max": 160,
      "step": 1,
      "default": 65,
      "unit": "mm"
    },
    {
      "key": "basePadSlotOuterDia",
      "label": "Pad Slot Outer Diameter",
      "min": 30,
      "max": 180,
      "step": 1,
      "default": 105,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "solara_vertical_fluted_shade",
      "label": "Solara Fluted Shade - Smooth Vertical Flutes",
      "default": "#FACC15",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [],
  "exportGroups": []
};
